export default __webpack_public_path__ + "static/media/awslogoo.316da603.png";